import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { MapaDialogComponent } from '../../../components/mapa-dialog/mapa-dialog.component';

@Component({
    selector: 'app-dlg-capturar-coords',
    templateUrl: './dlg-capturar-coords.component.html',
    styleUrls: ['./dlg-capturar-coords.component.scss']
})
export class DlgCapturarCoordsComponent {

    form: FormGroup;
    cita: any;

    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<DlgCapturarCoordsComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.cita = data.cita;
        this.form = this.fb.group({
            latitud:  ['', [Validators.required, Validators.pattern(/^-?\d+(\.\d+)?$/)]],
            longitud: ['', [Validators.required, Validators.pattern(/^-?\d+(\.\d+)?$/)]]
        });
    }

    cancelar(): void {
        this.dialogRef.close(null);
    }

    /**
     * Abre el MapaDialogComponent (mismo que usa el flujo de tipificacion del
     * agente) con la provincia / distrito / corregimiento de la cita, para que
     * la validacion bloqueante por corregimiento aplique aqui tambien.
     */
    abrirMapa(): void {
        const provNombre = this.cita && this.cita.provincia_nombre ? this.cita.provincia_nombre : '';
        const distNombre = this.cita && this.cita.distrito_nombre  ? this.cita.distrito_nombre  : '';

        // Corregimiento: viene en localizacion ("PROV-DIST-CORREGIMIENTO")
        let corregNombre = '';
        if (this.cita && this.cita.localizacion && typeof this.cita.localizacion === 'string') {
            const partes = this.cita.localizacion.split('-').map((p: string) => p.trim()).filter((p: string) => !!p);
            if (partes.length >= 3) {
                corregNombre = partes[partes.length - 1];
            }
        }

        const mapaData: any = {
            provincia: {
                idprovincia: this.cita ? this.cita.id_provincia : null,
                nombre: provNombre
            },
            distrito: {
                id: this.cita ? this.cita.id_distrito : null,
                nombre: distNombre
            },
            corregimiento: {
                id: this.cita ? this.cita.id_corregimiento : null,
                nombre: corregNombre
            }
        };

        // Si el form ya tiene lat/lng (capturados manualmente), pasarlos como
        // punto inicial al mapa.
        const latActual = parseFloat(this.form.value.latitud);
        const lngActual = parseFloat(this.form.value.longitud);
        if (!isNaN(latActual) && !isNaN(lngActual)) {
            mapaData.lat = latActual;
            mapaData.lng = lngActual;
        }

        const ref = this.dialog.open(MapaDialogComponent, {
            width: '80%',
            data: mapaData
        });

        ref.afterClosed().subscribe((result: any) => {
            if (result && typeof result.lat === 'number' && typeof result.lng === 'number') {
                this.form.patchValue({
                    latitud:  String(result.lat),
                    longitud: String(result.lng)
                });
            }
        });
    }

    guardar(): void {
        if (this.form.invalid) return;
        this.dialogRef.close({
            latitud:  this.form.value.latitud,
            longitud: this.form.value.longitud
        });
    }
}
